import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Navbar from "./components/Navbar";
import HeroCarousel from "./components/HeroCarousel";
import LoanTabsSection from "./components/Services";
import EMICalculator from "./components/Emi";
import WhyChooseUs from "./components/Choose";
import Homeabout from "./components/Homeabout";
import ServiceGrid from "./components/ServiceGrid";
import Footer from "./components/Footer";
import BlogArticlePage from "./components/BlogArticlePage";

import Career from "./pages/Career";
import AboutUs from "./pages/AboutUs";
import OurBlogs from "./pages/OurBlogs";
import AllBlogs from "./pages/AllBlogs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsCondition from "./pages/TermsCondition";
import Contact from "./pages/Contact";
import JobModal from "./components/JobModal";
import PersonalLoan from "./pages/PersonalLoan";
import VehicleLoan from "./pages/Vehicleloan";
import BusinessLoan from "./pages/BusinessLoan";
import LoanAgainstProperty from "./pages/LoanAgainstProperty";
import GoldLoan from "./pages/GoldLoan";
import HousingLoan from "./pages/HousingLoan";
import StepsTimeline from "./components/Stepline";
import Trademark from "./components/Trademark";
import Locate from "./pages/Locate";
import ScrollTop from "./components/ScrollTop";

function HomePage() {
  return (
    <>
      <HeroCarousel />
      <LoanTabsSection />
      <EMICalculator />
      <div className="row d-flex justify-content-center">
        <div className="col-10">
          <WhyChooseUs />
        </div>
        <div className="col-10">
          <StepsTimeline />
        </div>
      </div>
      <Trademark />
      <Homeabout />
      <ServiceGrid />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blogs" element={<OurBlogs />} />
        <Route path="/blog-article-page" element={<BlogArticlePage />} />
        <Route path="/all-blogs" element={<AllBlogs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/job-modal" element={<JobModal />} />
        <Route path="/personal-loan" element={<PersonalLoan />} />
        <Route path="/vehicle-loan" element={<VehicleLoan />} />
        <Route path="/business-loan" element={<BusinessLoan />} />
        <Route
          path="/loan-against-property"
          element={<LoanAgainstProperty />}
        />
        <Route path="/gold-loan" element={<GoldLoan />} />
        <Route path="/housing-loan" element={<HousingLoan />} />
        <Route path="/locate" element={<Locate />} />
      </Routes>
      <Footer />
    </Router>
  );
}
